import React, { useState } from 'react';
import { useSettings } from './SettingsContext';
import './MembershipStep.css';

const MembershipStep = ({ onComplete }) => {
    const { settings } = useSettings();
    const mem = settings.membership || {};

    const tiers = [
        { id: '1', label: mem.tier1Label || '1 Year', price: mem.tier1Price || '10' },
        { id: '2', label: mem.tier2Label || '3 Years', price: mem.tier2Price || '20' },
        { id: '3', label: mem.tier3Label || '5 Years', price: mem.tier3Price || '35' }
    ].filter(t => t.label && t.price);

    const [selectedTier, setSelectedTier] = useState(tiers[0]?.id);
    const [autoRenew, setAutoRenew] = useState(true);
    const [processing, setProcessing] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setProcessing(true);
        // Simulate processing delay
        setTimeout(() => {
            setProcessing(false);
            const tierData = tiers.find(t => t.id === selectedTier) || tiers[0];
            onComplete({ tier: tierData, autoRenew, provider: mem.providerName });
        }, 1500);
    };

    return (
        <div className="membership-section">
            <div className="membership-card">
                <div className="provider-header">
                    {mem.providerIcon && <img src={mem.providerIcon} alt="Provider" className="provider-icon" />}
                    <h2>{mem.providerName || 'Membership'}</h2>
                </div>
                <p className="step-instructions">Select your membership type and process payment</p>

                <form onSubmit={handleSubmit}>
                    <div className="tiers-container">
                        <h3>1. Select Membership Type</h3>
                        <div className="tiers-grid">
                            {tiers.map(tier => (
                                <div
                                    key={tier.id}
                                    className={`tier-card ${selectedTier === tier.id ? 'selected' : ''}`}
                                    onClick={() => setSelectedTier(tier.id)}
                                >
                                    <div className="tier-label">{tier.label}</div>
                                    <div className="tier-price">${tier.price}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="payment-container">
                        <h3>2. Payment Details</h3>
                        <div className="payment-form">
                            <label>
                                Card Number
                                <input type="text" value="**** **** **** 4242" readOnly className="dummy-input" />
                            </label>
                            <div className="payment-row">
                                <label>
                                    Expiry Date
                                    <input type="text" value="12/28" readOnly className="dummy-input" />
                                </label>
                                <label>
                                    CVC / CVV
                                    <input type="text" value="***" readOnly className="dummy-input" />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="auto-renew-container">
                        <label className="checkbox-label">
                            <input type="checkbox" checked={autoRenew} onChange={(e) => setAutoRenew(e.target.checked)} />
                            Enable Auto-Renewal
                            <span className="auto-renew-subtext">(You can cancel at any time)</span>
                        </label>
                    </div>

                    <button type="submit" className="action-button" disabled={processing}>
                        {processing ? 'Processing Payment...' : 'Complete Payment'}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default MembershipStep;
